import { render, staticRenderFns } from "./BaseInfoModalNew.vue?vue&type=template&id=d5f50e7c&scoped=true"
import script from "./BaseInfoModalNew.vue?vue&type=script&lang=js"
export * from "./BaseInfoModalNew.vue?vue&type=script&lang=js"
import style0 from "./BaseInfoModalNew.vue?vue&type=style&index=0&id=d5f50e7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f50e7c",
  null
  
)

export default component.exports